import axios from "axios";
import config from "@/router/globalConfig";

export default {
    //============= Post API ===============

    //======================================
    //============== Get API ===============
    GetSetup() {
        return axios.get(config.WEB_API_PATH + 'login/v1/GetSetup', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: ""
        });
    },
    CheckAuthentication(_data_) {
        return axios.get(config.WEB_API_PATH + 'login/v1/CheckAuthentication', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: ""
        });
    },
    GetCurrentUser(antiforgeryToken, authToken) {
        return axios.get(config.WEB_API_PATH + 'login/v1/GetCurrentUser', {
            headers: { __RequestVerificationToken: antiforgeryToken, Authorization: authToken },
            params: ""
        });
    },
    GetHelpFile(antiforgeryToken, authToken) {
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetHelpFile', {
            headers: { __RequestVerificationToken: antiforgeryToken, Authorization: authToken },
            params: ""
        });
    },
    //======================================
}


// WEBPACK FOOTER //
// ./src/components/serviceJS/masterJS.js